export default {
    INITIALIZED: 'INITIALIZED',
    RESET: 'RESET',
    REQUEST_PENDING: 'REQUEST_PENDING',
    REQUEST_SUCCESS: 'REQUEST_SUCCESS',
    REQUEST_ERROR: 'REQUEST_ERROR'
}